import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { gql } from '@apollo/client';
import { nullable } from '@infl-ts/util-io-ts';
import { makeDecodedQuery } from '@infl-ts/util-make-apollo-decoded';
import * as t from 'io-ts';
export var EntityBannerImageResult = t.type({
  entity: t.type({
    id: t.string,
    pageBanner: nullable(t.type({
      id: t.string,
      url: t.string
    }))
  })
});
export var useEntityBannerImage = makeDecodedQuery(gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query EntityBannerImage($id: ID!) {\n      entity: node(id: $id) {\n        id\n        ... on Channel {\n          pageBanner {\n            id\n            url\n          }\n        }\n      }\n    }\n  "]))), EntityBannerImageResult, t.type({
  id: t.string
}));